import { useEffect, useState } from "react";
import Table from "../../Reusable/Table/Table1";
import { CheckCircleOutlined, EditOutlined, CloseCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import DropdownButton from "../../Reusable/dropdown/Drop";
import ReusableModal from "../../Reusable/Model/Model";
import ReusableDrawer from "../../Reusable/Drawer/Drawer";
import { Form, Input, Radio, InputNumber, Tag } from 'antd';


import { Button, message } from 'antd';
import CustomSelect from "../../Reusable/Select/Select";
import AvatarUploader from "../../Reusable/Avatar/Avatar";
import axios from "axios";
import consts from "../../constant";
import EditableTable from "../../Reusable/Table/EditableTable";

import formatCustomDate from "../../helpers/formatDateandTime";
import dayjs from "dayjs";
import { DatePicker } from 'antd';
const { RangePicker } = DatePicker;
const PositionOrders = () => {
  const [open, setOpen] = useState(false);
  const [openBlock, setOpenBlock] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("Content of the modal");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [orderTyp, setOrderTyp] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();
  const [formLayout, setFormLayout] = useState('vertical');
  const [selected, setSelected] = useState("Percentage");
  const [avatar, setAvatar] = useState(localStorage.getItem("avatar") || null);
  const [page, setPage] = useState(null)
  const [history, setHistory] = useState([]);
  const [totalPage, setTotalPage] = useState([])
  const [positionStartDate, setPositionStartDate] = useState(dayjs().subtract(6, "day"));
  const [endPositionDate, setEndPositionDate] = useState(dayjs());
  console.log(orderTyp, 'orderTyp');
  const { Search } = Input;


  const handleChange = (value) => {
    console.log("Selected:", value);
    setSelected(value);
  };

  const options = [
    { value: "Percentage", label: "Percentage" },
    { value: "Fixed", label: "Fixed" },
  ];



  const success = () => {
    messageApi.open({
      type: 'success',
      content: 'User Blocked',
    });
  };

  const showDrawer = (user) => {
    setSelectedUser(user);
    setOpenDrawer(true);
  };

  const onClose = () => {
    setOpenDrawer(false);
    setSelectedUser(null);
  };




  const handleOk = () => {
    setModalText("The modal will be closed after two seconds");
    setConfirmLoading(true);
    setTimeout(() => {
      setOpen(false);
      setConfirmLoading(false);
    }, 2000);
  };

  const handleOkBlock = () => {
    setModalText("The modal will be closed after two seconds");
    setConfirmLoading(true);
    setTimeout(() => {
      setOpenBlock(false);
      setConfirmLoading(false);
      success()
    }, 2000);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleCancelBlock = () => {
    setOpenBlock(false);
  };

  const handleMenuClick = (e, user) => {
    console.log("Clicked:", e);
    if (e.key === "1") {
      // View
      showDrawer(user);
    }
  };

  const handleAvatarChange = (url) => {
    setAvatar(url);
    localStorage.setItem("avatar", url); // persist locally
  };
  const items = (user) => [
    { label: "Edit", key: "1", icon: <EditOutlined /> },

  ];

  const userColumns = [
    { title: "Sno", dataIndex: "sno", key: "sno" },
    { title: "User", dataIndex: "user", key: "user" },
    { title: "Date & Time", dataIndex: "createdAt", key: "createdAt" },
    { title: "Pair", dataIndex: "symbol", key: "symbol" }, // editable
    { title: "Trade Type", dataIndex: "types", key: "types" },
    { title: "Order Type", dataIndex: "order_type", key: "order_type" },
    { title: "Side", dataIndex: "trade_type", key: "trade_type" },
    { title: "Order Price", dataIndex: "price", key: "price", editable: (record) => record.order_type !== "market", inputType: "number", fixed: "right" },
    { title: "Order Quantity", dataIndex: "volume", key: "volume", editable: true, inputType: "number", fixed: "right" },
    { title: "Total ", dataIndex: "total", key: "total", editable: true, inputType: "number", fixed: "right" },
    { title: "Fee", dataIndex: "fees", key: "fees" },
    { title: "Status", dataIndex: "status", key: "status" },
  ];



  const getTransHistory = async (value) => {
    setConfirmLoading(true);
    try {
      const { data } = await axios.post(
        `${consts.BackendUrl}/admin/getPositionHistory?page=${page?.current ? page?.current : 1}&limit=10`,
        {
          search: value, pending: "pending", startDate: positionStartDate && positionStartDate.toISOString(),
          endDate: endPositionDate && endPositionDate.toISOString()
        },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      )

      if (data?.success == true && data?.result?.docs) {
        var dts = data?.result?.docs;
        console.log(dts, 'histdata');
        var totalCount = data?.result?.totalDocs;
        console.log(data?.result?.totalDocs, 'totalCount');
        // var totalCount = data?.result?.totalDocs;
        // Map backend data into the table format
        const mappedData = dts.map((user, index) => {
          // if you want to store something in state, do it outside the return
          setOrderTyp(user);
          console.log(user, 'user');
          return {
            ...user,
            key: index, // REQUIRED for AntD Table
            sno: page?.current ? (page?.current - 1) * page?.pageSize + index + 1 : index + 1,
            user: user?.user?.name,
            createdAt: formatCustomDate(user?.createdAt),
            symbol: user?.symbol,
            order_type: user?.order_type,
            trade_type: user?.trade_type,
            volume: user?.volume,
            fees: user?.fees,
            types: user?.types,
            price: user?.price ? user?.price : "-",
            total: user?.volume * user?.price,
            status: user?.status,
          };
        });


        console.log(mappedData, 'dts');
        setTotalPage(totalCount)
        setHistory(mappedData);

      } else {
        setHistory([]);
        setTotalPage(0);
      }

    } catch (error) {
      setHistory([]);
      setTotalPage(0);
      console.log(error?.response?.data?.message);

    }
    setConfirmLoading(false);
  }

  const newValues = (values) => {
    console.log(values, 'values');
    completeTrade(values);

  }
  const completeTrade = async (trade) => {
    console.log(trade, 'tradeId');

    try {
      const { data } = await axios.post(
        `${consts.BackendUrl}/closePosition`, // ✅ pass tradeId to API
        {
          ...trade

        },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );

      if (data?.success) {

        messageApi.open({
          type: 'success',
          content: "Trade Filled successfully",
        });
        getTransHistory(); // refresh table after closing
      }
    } catch (error) {
      console.log(error?.response?.data?.message);
      message.error("Failed to close trade");
    }
  };
  const handlePositiondate = (date) => {
    console.log(date, "date");
    if (!date) {
      setPositionStartDate(null);
      setEndPositionDate(null);
      return;
    }
    setPositionStartDate(date[0]);
    setEndPositionDate(date[1]);
    getTransHistory();
    console.log(positionStartDate?.toISOString(), endPositionDate?.toISOString(), "future");
  }
  useEffect(() => {
    getTransHistory()
  }, [page, positionStartDate, endPositionDate])
  return (
    <>

      <div className="display-2 p-10">
        <h2>
          Position Orders
        </h2>
        <div>

          <Search placeholder="Search for name or pair" onSearch={getTransHistory} allowClear style={{ width: 200 }} loading={confirmLoading} className="input-cls" />
          <RangePicker style={{ marginLeft: 10, width: 250 }} onChange={handlePositiondate} value={[positionStartDate, endPositionDate]} className="input-cls" />
        </div>
      </div >
      <EditableTable
        dataSource={history}
        columnsConfig={userColumns}
        // onSave={handleSave}
        total={totalPage}
        pageSize={page?.pageSize ? page?.pageSize : 10}
        className="mt-20 tabs"
        completeTrade={completeTrade}
        newValues={newValues}
        onChange={(pagination, filters, sorter) => {
          console.log("Table params:", pagination, filters, sorter);
          setPage(pagination)
        }}
      />

      <ReusableModal
        title="Confirm Delete"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <p>{modalText}</p>
      </ReusableModal>
      <ReusableModal
        title="Confirm Block"
        open={openBlock}
        onOk={handleOkBlock}
        confirmLoading={confirmLoading}
        onCancel={handleCancelBlock}
      >
        <p>{modalText}</p>
      </ReusableModal>

      <ReusableDrawer open={openDrawer} onClose={onClose} title="Edit History"

        extra={
          <CloseCircleOutlined className="cursor" onClick={onClose} />
        }
      >
        {selectedUser ? (
          <div>

            <Form
              layout={formLayout}
              form={form}

              style={{ maxWidth: formLayout === 'inline' ? 'none' : 600 }}
            >
              {/* <Form.Item label="Asset Image">
                                <AvatarUploader />
                            </Form.Item> */}
              <Form.Item label="Price">
                <InputNumber placeholder="enter base name" style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item label="Quantity">
                <InputNumber placeholder="enter market name" style={{ width: "100%" }} />
              </Form.Item>

              <Form.Item label="Volume">
                <InputNumber placeholder="enter trade commission" style={{ width: "100%" }} />
              </Form.Item>

              <div className="display-2">
                <Button type="primary"
                  color="cyan"
                  variant="solid"
                  // loading={true}
                  iconPosition="end"
                >Approve</Button>

                <Button type="primary"
                  variant="outlined"
                  color="danger"
                  // loading={true}
                  iconPosition="end"
                  onClick={onClose}
                >Cancel</Button>
              </div>
            </Form>

          </div>
        ) : (
          <p>No user selected</p>
        )}
      </ReusableDrawer>


      {contextHolder}
    </>
  );
};

export default PositionOrders;
